import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import reducers from './reducers';

export default (history, initialState = {}, thunkDependencies = {}) => {
  // combine app reducers with react-router, so we sync history updates with redux store
  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer,
  });

  const middlewares = [
    // allow using action creators that correspond with the history/router methods of the same names; usage:
    // import { push, replace, go, goBack, goForward } from 'react-router-redux'
    // store.dispatch(push(location));
    // store.dispatch(replace(location));
    // store.dispatch(go(number));
    // store.dispatch(goBack());
    // store.dispatch(goForward());
    // these action creators are also available in one single object as routerActions, which can be used as
    // a convenience when using Redux's bindActionCreators()
    routerMiddleware(history),

    // enable simple Dependency Injection in Redux Thunk's action creators; usage:
    // function someAction(...arguments...) {
    //   return (dispatch, getState, { dependencies }) => {
    //     ...action logic...         \            /
    //   }                             (magic here)
    // }
    thunkMiddleware.withExtraArgument({
      ...thunkDependencies,
      router: history, // if, for any reason, dispatching the router actions is not sufficient
    }),
  ];

  // enable using Chrome/Firefox Redux DevTools Extension; for config options see
  // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
  const composeEnhancers = composeWithDevTools({});

  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));
};
